module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carte-conge-light",
    class: {
      skeleton: !_vm.dataReady
    },
    attrs: {
      "data-testid": 'carteCongeLight-section-' + _vm.typeConge
    }
  }, [_c('div', {
    staticClass: "top-data"
  }, [_c('h2', {
    class: {
      skeleton: !_vm.dataReady
    },
    attrs: {
      "data-testid": "carteCongeLight-title"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.dataReady ? _vm.compteur.title : '') + "\n        ")]), _vm._v(" "), _c('h3', {
    class: {
      skeleton: !_vm.dataReady
    },
    style: (_vm.dataReady ? {
      color: _vm.compteur.data.joursRestantsColor
    } : {}),
    attrs: {
      "data-testid": "carteCongeLight-nbJoursRestants"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.dataReady ? _vm.formatNumber(this.compteur.data.joursRestants) + ' j. restants' : '') + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-data"
  }, [_c('div', {
    staticClass: "detail"
  }, [_c('span', {
    staticClass: "dot",
    class: {
      skeleton: !_vm.dataReady
    },
    style: (_vm.dataReady ? {
      backgroundColor: _vm.compteur.data.joursPosesColor
    } : {})
  }), _vm._v(" "), _c('h4', {
    class: {
      skeleton: !_vm.dataReady
    }
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm.dataReady ? 'Posés' : '') + "\n                ")]), _vm._v(" "), _c('span', {
    style: (_vm.dataReady ? {
      color: _vm.compteur.data.joursPosesColor
    } : {}),
    attrs: {
      "data-testid": "carteCongeLight-nbJoursPoses"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.dataReady ? _vm.formatNumber(_vm.compteur.data.joursPoses) : '') + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', {
    staticClass: "dot",
    class: {
      skeleton: !_vm.dataReady
    },
    style: (_vm.dataReady ? {
      backgroundColor: _vm.compteur.data.joursPrisColor
    } : {})
  }), _vm._v(" "), _c('h4', {
    class: {
      skeleton: !_vm.dataReady
    }
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm.dataReady ? 'Pris' : '') + "\n                ")]), _vm._v(" "), _c('span', {
    attrs: {
      "data-testid": "carteCongeLight-nbJoursPris"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.dataReady ? _vm.formatNumber(_vm.compteur.data.joursPris < 0 ? 0 : _vm.compteur.data.joursPris) : '') + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', {
    staticClass: "dot",
    class: {
      skeleton: !_vm.dataReady
    },
    style: (_vm.dataReady ? {
      backgroundColor: _vm.compteur.data.joursAcquisColor
    } : {})
  }), _vm._v(" "), _c('h4', {
    class: {
      skeleton: !_vm.dataReady
    }
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm.dataReady ? 'Acquis' : '') + "\n                ")]), _vm._v(" "), _c('span', {
    style: (_vm.dataReady ? {
      color: _vm.compteur.data.joursAcquisColor
    } : {}),
    attrs: {
      "data-testid": "carteCongeLight-nbJoursPoses"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.dataReady ? _vm.formatNumber(_vm.compteur.data.joursAcquis) : '') + "\n                ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50ce0c68"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsencesV2/carteCongeLight/carteCongeLight.vue.html
// module id = O+4v
// module chunks = 2